<style>

</style>
<template>
  <v-layout row wrap>
    <v-flex xs12 sm6 md6>
      <v-menu
        v-model="menuFrom"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dateFrom"
            label="From"
            hint="YYYY/MM/DD format"
            prepend-icon="event"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="dateFrom" @input="menuFrom = false"></v-date-picker>
      </v-menu>
    </v-flex>
    <v-spacer></v-spacer>
    <v-flex xs12 sm6 md6>
      <v-menu
        v-model="menuTo"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dateTo"
            label="To"
            hint="YYYY/MM/DD format"
            prepend-icon="event"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="dateTo" @input="menuTo = false"></v-date-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
    props:['chart'],
    data: function() {
      return {
        dateFrom: new Date().toISOString().substr(0, 10),
        dateTo: new Date().toISOString().substr(0, 10),
        menu: false,
        menuFrom: false,
        menuTo: false,
        modal: false,
        menu2: false
      };
    },
    methods: {
      rendered: function() {

      }
    },
    computed: {

    },
    components: {

    },
    mounted: function() {
    }
}

</script>
